import type { Styles } from 'common/types';

export const styles: Styles = {
  authorOption: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    p: 1,
  },
  authorInfo: {
    display: 'flex',
    flexDirection: 'column',
  },
  authorName: {
    fontSize: '0.9rem',
    fontWeight: 500,
    color: 'text.primary',
  },
  authorFirstName: {
    fontSize: '0.75rem',
    color: 'text.secondary',
  },
};
